import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={20}
    height={18}
    fill="none"
    className="cloud-icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.12.893a5.838 5.838 0 0 0-5.382 3.523 4.075 4.075 0 0 0-1.595-.333 3.944 3.944 0 0 0-3.714 2.571c-.143-.047-.262-.047-.405-.047C1.357 6.607 0 7.94 0 9.583s1.357 2.976 3.024 2.976h2.452a.478.478 0 0 0 .477-.476.478.478 0 0 0-.477-.476H3.024c-1.167 0-2.072-.881-2.072-2.024S1.857 7.56 3.024 7.56c.214 0 .405.024.595.096.12.047.262.023.38-.048a.525.525 0 0 0 .239-.31 3.005 3.005 0 0 1 2.928-2.285c.572 0 1.12.166 1.596.476a.49.49 0 0 0 .404.048.465.465 0 0 0 .286-.31 4.911 4.911 0 0 1 4.667-3.381c2.715 0 4.929 2.19 4.929 4.88 0 2.691-2.214 4.882-4.929 4.882a.478.478 0 0 0-.476.476c0 .262.214.476.476.476C17.357 12.56 20 9.94 20 6.726S17.357.893 14.12.893Z"
      fill="#1D1D1D"
    />
    <path
      d="M11.643 8.773a.147.147 0 0 0-.167.024L8.5 13.083c-.024.048-.024.095 0 .119.024.048.071.071.095.071h1.357l-1.785 3.643c-.024.048 0 .12.047.167.024 0 .048.024.072.024.047 0 .071-.024.095-.048l2.976-4.286c.024-.047.024-.095 0-.119-.024-.047-.071-.071-.095-.071H9.905L11.69 8.94c.023-.071 0-.143-.048-.167Z"
      fill="#1D1D1D"
    />
  </svg>
);

export default SvgComponent;
